import type { IconData } from '@stacksjs/iconify-core'

export const videoMoviesVintageTv3: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 8.375H16.76v-1.52h-3.04v1.52H1.53v1.53h24.38v18.28H1.53v1.53h28.95v-1.53H32V9.905h-1.52z\"/><path fill=\"currentColor\" d=\"M21.33 25.145h3.05v1.52h-3.05Zm0-3.05h3.05v1.52h-3.05Zm0-6.1h3.05v3.05h-3.05Zm0-4.57h3.05v3.05h-3.05Zm-1.52-9.14h1.52v1.52h-1.52Zm-1.52 10.66h1.52v12.2h-1.52Zm0-9.14h1.52v1.53h-1.52Zm-1.53 1.53h1.53v1.52h-1.53Zm-4.57 0h1.53v1.52h-1.53Zm-1.52-1.53h1.52v1.53h-1.52Zm-1.53-1.52h1.53v1.52H9.14Z\"/><path fill=\"currentColor\" d=\"M16.76 12.945h1.53v-1.52H4.57v1.52H6.1v12.2H4.57v1.52h13.72v-1.52h-1.53Zm-6.09 12.2H9.14v-12.2h1.53Zm3.05 0h-1.53v-12.2h1.53Zm-10.67-12.2h1.52v12.2H3.05ZM0 9.905h1.53v18.28H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default videoMoviesVintageTv3
